var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stats-card-v2',{attrs:{"colClasses":"xs12","heading":_vm.widget.text.caption[_vm.$i18n.locale],"amount":_vm.value,"is-cash":_vm.isMoneyValue}})}
var staticRenderFns = []

export { render, staticRenderFns }